export const TOAST_MESSAGES = {
    CLIENT_FETCH_FAILED: "Failed to fetch Clients.",
    UPDATE_CLIENT_FAILED: "Failed to update Client",
    UPDATE_CLIENT_SUCCESS: "Client updated successfully",
    CLIENT_CREATE_FAILED: "Failed to create Client",
    CLIENT_SUCCESS: "Client created successfully",
    DELETE_CLIENT_SUCCESS: "Client deleted successfully",
    DELETE_CLIENT_FAILED: "Failed to delete Client!",
    DELETE_CLIENT_ERROR: "Error deleting Client!",
    CLIENT_DELETE_ALERT: "Are you sure you want to delete this Client?"
}

export const CLIENT_COLUMNS = [
    "name",
    "contact_person_name",
    "mobile",
    "address",
    "gst_details",
    "actions",
]

export const CLIENT_LABELS = {
    name: "Client Name",
    contact_person_name: "Contact Person Name",
    mobile: "Mobile",
    address: "Address",
    gst_details: "GSTIN",
    actions: "Actions",
};

export const CLIENT_MODES = {
    EDIT: "edit",
    VIEW: "view",
    CREATE:"create",
};
